import { Container, Row, Col } from 'react-bootstrap'
import { useTenantProfile } from 'hooks/api/tenant/useTenantProfile'
import Button from 'components/common/Button'
import Text from 'components/common/Text'
import Link from 'components/common/Link'

export const BecomePartnerBlock = () => {
	const { data: tenantProfile } = useTenantProfile()
	const primaryColor = tenantProfile?.theme?.primaryColor

	return (
		<Container style={{ display: 'flex', flexDirection: 'column', gap: 40 }}>
			<div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
				<Row>
					<Col>
						<Text
							size={34}
							style={{
								fontWeight: 'bold',
								textAlign: 'center',
							}}
						>
							Create a Profile Today!
						</Text>
					</Col>
				</Row>
				<Row>
					<Col xs={12} md={{ span: 8, offset: 2 }}>
						<Text size={18} align={'center'}>
							Your clients need help making sure their property taxes are fair. Partner with us and
							let's serve homeowners with excellence together.
						</Text>
					</Col>
				</Row>
				<div style={{ display: 'flex', justifyContent: 'center' }}>
					<Link to='/partners/signup'>
						<Button
							background={primaryColor}
							style={{
								width: 'auto',
								textAlign: 'center',
								paddingLeft: 30,
								paddingRight: 30,
								paddingTop: 15,
								paddingBottom: 15,
								height: 'auto',
							}}
						>
							Let’s Do This!
						</Button>
					</Link>
				</div>
			</div>
		</Container>
	)
}
